<div class="suspender-regras-dialog">
  <div class="suspender-regras-dialog__warning">
    ATENÇÃO: ao suspender as regras para um dia, o titular poderá emitir convites
    sem nenhum limite (diário, sub-limite de pagos, anual e a trava de emissão paga).
    A suspensão pode ser cancelada na lista de "Suspensões de regras" enquanto vigorar.
  </div>

  <div class="suspender-regras-dialog__form">
    <div class="new-form-control-sm suspender-regras-dialog__field">
      <label for="suspensionDate">Data</label>
      <p-calendar
        inputId="suspensionDate"
        name="suspensionDate"
        [(ngModel)]="date"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        appendTo="body"
      ></p-calendar>
    </div>

    <div class="new-form-control-sm suspender-regras-dialog__field suspender-regras-dialog__field--note">
      <label for="suspensionNote">Motivo (opcional)</label>
      <input
        pInputText
        id="suspensionNote"
        name="suspensionNote"
        type="text"
        [(ngModel)]="note"
        placeholder="Ex: evento especial, aniversário do titular..."
        maxlength="255"
      />
    </div>
  </div>

  <div class="suspender-regras-dialog__footer">
    <button type="button" class="new-easymarine disabled" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="new-easymarine primary" (click)="confirm()">
      Suspender regras
    </button>
  </div>
</div>
